import React, { useState } from 'react'
import Card from "../components/card/card";
import Filter from "../components/filter";
import CoverLoading from "../components/cover-loading";
import {Link} from "react-router-dom";


const TourPackages = () => {
    const [post,setPost] = useState([])
    const [loading,setLoading] = useState(false)
    return (
        <div className='main-container justify-content-start'>
            {loading ? <CoverLoading/> : ''}
            <Filter path='tour-package' setPost={setPost} setLoading={setLoading}/>
            <div className="row justify-content-end">
                <div className="col-2">
                    <Link to={'/add-tour-package'} className='btn btn-primary'>Create Package</Link>
                </div>
            </div>
            <div className="list-posts">
                {post.map((e)=><Card path='tour-package' post={post} setPost={setPost} setLoading={setLoading} key={e.id} data={e}/>)}
            </div>
        </div>
    );
};

export default TourPackages